import "date-fns";
import DateFnsUtils from "@date-io/date-fns";
import React, { useState, useEffect } from "react";
import { Box, makeStyles, Typography, Button } from "@material-ui/core";
import InputWithLabel from "../Inputs/InputWithLabel";
import CustomCheckbox from "../Inputs/CustomCheckbox";
import Label from "../Misc/Label";
import InputWithHorizontalLabel from "../Inputs/InputWithHorizontalLabel";

import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from "@material-ui/pickers";

const useStyles = makeStyles((theme) => ({
  container: {
    // background: "#FFFFFF",
    // boxShadow: "4px 4px 30px rgba(34, 43, 69, 0.08)",
    // borderRadius: "8px",
    // padding: 24,
  },
  pageHeading: {
    fontWeight: "700",
    fontSize: "2.4rem",
    // lineHeight: "3.2rem",
    marginBottom: 6,
  },

  headingDesc: {
    fontWeight: "400",
    fontSize: "1.4rem",
    lineHeight: "2.4rem",
    color: "rgba(0,0,0, 0.46)",
  },
  pink: {
    color: "#F630A9",
    fontSize: "2.4rem",
    fontWeight: "700",
    marginLeft: "5px",
  },
  stepHeader: {
    marginBottom: "3rem",
  },
  flex: {
    display: "flex",
    // alignItems:"center",
  },
}));

const TokenPoolReqStepTwo = ({ setDisableButton }) => {
  const classes = useStyles();
  useEffect(() => {
    setDisableButton(false);
  }, []);

  return (
    <Box className={classes.container}>
      <Box className={classes.stepHeader}>
        <Box className={classes.flex}>
          <Typography className={classes.pageHeading}>Step 3</Typography>
          <Typography className={classes.pink}> (Coming Soon)</Typography>
        </Box>

        <Typography className={classes.headingDesc}>
          Choose Target geography for your campaign
        </Typography>
      </Box>
    </Box>
  );
};

export default TokenPoolReqStepTwo;
